import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';

import { nodePropType } from '../propTypes';
import TreeContext from '../TreeContext';
import TreeBodyContent from './TreeBodyContent';

export default function TreeBody({ filter: bodyFilter, models: bodyModels }) {
  const {
    tree,
    adapter,
    plugins,
    selection,
    onSelectionChange,
    handleClear,
    context,
    models: contextModels,
    filter: contextFilter,
    hasBottomPadding,
    isScrollDisabled,
  } = useContext(TreeContext);

  const models = useMemo(() => {
    if (!contextModels) {
      return bodyModels || [];
    }

    if (!bodyModels) {
      return contextModels || [];
    }

    return [...contextModels, ...bodyModels];
  }, [bodyModels, contextModels]);

  return (
    <TreeBodyContent
      adapter={adapter}
      context={context}
      filter={bodyFilter || contextFilter}
      handleClear={handleClear}
      hasBottomPadding={hasBottomPadding}
      isScrollDisabled={isScrollDisabled}
      models={models}
      plugins={plugins}
      selection={selection}
      tree={tree}
      onSelectionChange={onSelectionChange}
    />
  );
}

TreeBody.propTypes = {
  filter: nodePropType,
  models: PropTypes.arrayOf(nodePropType),
};

TreeBody.defaultProps = {
  filter: null,
  models: null,
};
